import { useQuery } from "@tanstack/react-query";
import { getAllUsers } from "../../services/users";

const useGetUsers = () => {
    return useQuery({
        queryKey: ["users"],
        queryFn: getAllUsers,
        staleTime: Infinity,
    });
}

export default useGetUsers;